module.exports = __webpack_public_path__ + "img/CandlesIcon.3bef3568.svg";